import { useToggle } from "@mantine/hooks";
import { useRouter } from "next/router";

import { storeCTEvent }          from "_analytics/index";
import { shortenNumber }         from "_common/utils";
import { createURLSearchParams } from "_common/webview";
import BackgroundWrapper         from "_components/atoms/backgroundWrapper";
import Typography                from "_components/atoms/typography";
import ViewDetailedBtn           from "_components/features/creatorDashboard/atoms/viewDetailedBtn";
import DateRangeFilter           from "_components/features/creatorDashboard/molecules/dateRangeFilter";
import StatsBlock                from "_components/features/creatorDashboard/molecules/statsBlock";

import useStyles      from "./styles";
import { trimNumber } from "./utils";

const ChannelAnalytics = ( { analytics, updateData, filterCategories, isMobile, isMigratingData } ) => {

	const {
		diffFollowers,
		diffViews,
		diffWatchMinutes,
		totalFollowers,
		totalViews,
		totalWatchMinutes,
		diffRevenue,
		totalRevenue
	} = analytics;

	const router                         = useRouter ();
	const [ dateRange, toggleDateRange ] = useToggle ( [ "all", "30", "7" ] );
	const { classes }                    = useStyles ( undefined, { name: "styles" } );

	const handleOpenPage = () => {
		if ( isMigratingData )
			return;
		// handle webview params if they're present, would still work otherwise
		const params = createURLSearchParams ( router.query );

		const ctOptions = {
			eventProperty : "CO_View_detailed_click",
			value         : true
		};

		storeCTEvent ( "creator_dashboard_navigation", ctOptions );

		router.push ( `channel-analytics${ params }` );
	};

	return (
		<BackgroundWrapper
			className = { classes.analyticsRoot }
			type      = "primary"
		>
			<div className = { classes.headerDiv }>
				<Typography className = { `${ classes.title } fontWeightBold` }
					title                = { "Channel Analytics" }
				/>

				<DateRangeFilter
					dateRange        = { dateRange }
					filterCategories = { filterCategories }
					isMobile         = { isMobile }
					toggleDateRange  = { toggleDateRange }
					updateData       = { updateData }
				/>
			</div>

			<div className = { classes.contentDiv }>
				<StatsBlock
					dateRange = { dateRange }
					diff      = { diffFollowers }
					isMobile  = { isMobile }
					title     = { "Total Followers" }
					total     = { !totalFollowers ? "-" : shortenNumber ( trimNumber ( totalFollowers, 0 ) ) }
				/>

				<StatsBlock
					dateRange = { dateRange }
					diff      = { trimNumber ( diffViews, 1 ) }
					isMobile  = { isMobile }
					title     = { "Total Views" }
					total     = { !totalViews ? "-" : shortenNumber ( Number ( totalViews ) ) }
				/>

				<StatsBlock
					dateRange = { dateRange }
					diff      = { Math.floor ( Number ( diffWatchMinutes ) / 60 ) }
					isMobile  = { isMobile }
					title     = { "Total Watch Hours" }
					total     = { !totalWatchMinutes ? "-" : shortenNumber ( Math.floor ( Number ( totalWatchMinutes ) / 60 ) ) }
				/>

				<StatsBlock
					dateRange = { dateRange }
					diff      = { trimNumber ( diffRevenue, 2 ) }
					isMobile  = { isMobile }
					title     = { "Total Revenue (₹)" }
					total     = { !totalRevenue ? "-" : shortenNumber ( trimNumber ( totalRevenue, 2 ) ) }
				/>

			</div>

			<ViewDetailedBtn onClick = { handleOpenPage } />
		</BackgroundWrapper>
	);
};

export default ChannelAnalytics;